<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment" style="padding-top:150px;">
<p style="text-indent:0px;">We are but visiting this earth…</p>
<p style="text-indent:0px;">It is not the length of our stay which matters</p>
<p style="text-indent:0px;">so much as the footprints we leave behind…</p>
<p style="text-indent:0px;">The impression we make upon humanity…</p><br/>
<p style="text-indent:0px;">A man’s value is measured by how long he is</p>
<p style="text-indent:0px;">remembered after he is gone…</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?56d4ac17